<script setup lang="ts">
import './assets/style.scss'
import { useConfirm, VIcons } from '@/shared/ui'
import { useObjectTypeDuplicate } from './../model/api.ts'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  object_id: {
    type: String,
    required: true,
  },
})
const { trs } = useTranslate()
const { show } = useConfirm()
const emits = defineEmits(['duplicated'])

const { duplicate } = useObjectTypeDuplicate(props.id, Number(props.object_id))

/**
 * Функция дублирования типа инвентаризационного объекта
 */
const clickHandler = () => {
  show({
    confirmFunc: () => duplicate().then(() => emits('duplicated')),
    title: trs('itf.inventory_object_types_duplicate'),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.duplicate')">
    <template #activator="{ props: tooltipProps }">
      <VBtn icon density="compact" color="warning" v-bind="tooltipProps" @click="clickHandler">
        <VIcons type="library_add" />
      </VBtn>
    </template>
  </VTooltip>
</template>
